import * as React from "react";
import { forwardRef } from "react";
const SvgDateOverride = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 10H24V14H0V10Z", fill: "#55ADD4" }));
const ForwardRef = forwardRef(SvgDateOverride);
export { ForwardRef as ReactComponent };
